import { createTranslator } from "next-intl";

import { SupportedLocale } from "@/enums/locale.enum";

import { localizedMessagesSources } from "./localizedMessagesSources";

const cache = new Map<SupportedLocale, ReturnType<typeof createTranslator>>();

export function getTranslatorByLocale(
  locale: SupportedLocale,
  namespace: string = "common",
) {
  if (!cache.has(locale)) {
    cache.set(
      locale,
      createTranslator({
        locale,
        messages: { [namespace]: localizedMessagesSources[locale] },
      }),
    );
  }

  return cache.get(locale)!;
}
